"use strict";

const RoutineInspectionRouteFactory = require("./routineInspectionRouteFactory");

const SamplingSiteRoutes = function () {
  const inspectionRoute = RoutineInspectionRouteFactory.createRoute({
    resourceKey: "samplingSiteInspection",
    assetType: "sampling-site",
  });

  const legacyRedirectRoute = RoutineInspectionRouteFactory.createLegacyRedirect({
    assetType: "samplingSite",
    dataView: "sampling-site",
  });

  return { inspectionRoute, legacyRedirectRoute };
};

module.exports = SamplingSiteRoutes();
